// SPDX-License-Identifier: EPL-2.0

// Generated by scripts/generate-presentation.cjs from emojibase-data 16.0.3.
// Only FE0F-qualified sequences, factored into exact prefix/suffix combinations.
export const emojiPresentationGroups: Array<[string, string[]]> = [
  [
    '#️⃣ *️⃣ 0️⃣ 1️⃣ 2️⃣ 3️⃣ 4️⃣ 5️⃣ 6️⃣ 7️⃣ 8️⃣ 9️⃣ ©️ ®️ ‼️ ⁉️ ™️ ℹ️ ↔️ ↕️ ↖️ ↗️ ↘️ ↙️ ↩️ ↪️ ⌚️ ⌛️ ⌨️ ⏏️ ⏩️ ⏪️ ⏫️ ⏬️ ⏭️ ⏮️ ⏯️ ⏰️ ⏱️ ⏲️ ⏳️ ⏸️ ⏹️ ⏺️ Ⓜ️ ▪️ ▫️ ▶️ ◀️ ◻️ ◼️ ◽️ ◾️ ☀️ ☁️ ☂️ ☃️ ☄️ ☎️ ☑️ ☔️ ☕️ ☘️ ☝️ ☠️ ☢️ ☣️ ☦️ ☪️ ☮️ ☯️ ☸️ ☹️ ☺️ ♀️ ♂️ ♈️ ♉️ ♊️ ♋️ ♌️ ♍️ ♎️ ♏️ ♐️ ♑️ ♒️ ♓️ ♟️ ♠️ ♣️ ♥️ ♦️ ♨️ ♻️ ♾️ ♿️ ⚒️ ⚓️ ⚔️ ⚕️ ⚖️ ⚗️ ⚙️ ⚛️ ⚜️ ⚠️ ⚡️ ⚧️ ⚪️ ⚫️ ⚰️ ⚱️ ⚽️ ⚾️ ⛄️ ⛅️ ⛈️ ⛎️ ⛏️ ⛑️ ⛓️ ⛔️ ⛩️ ⛪️ ⛰️ ⛱️ ⛲️ ⛳️ ⛴️ ⛵️ ⛷️ ⛸️ ⛹️ ⛺️ ⛽️ ✂️ ✅️ ✈️ ✉️ ✊️ ✋️ ✌️ ✍️ ✏️ ✒️ ✔️ ✖️ ✝️ ✡️ ✨️ ✳️ ✴️ ❄️ ❇️ ❌️ ❎️ ❓️ ❔️ ❕️ ❗️ ❣️ ❤️ ➕️ ➖️ ➗️ ➡️ ➰️ ➿️ ⤴️ ⤵️ ⬅️ ⬆️ ⬇️ ⬛️ ⬜️ ⭐️ ⭕️ 〰️ 〽️ ㊗️ ㊙️ 🀄️ 🅰️ 🅱️ 🅾️ 🅿️ 🈂️ 🈚️ 🈯️ 🈷️ 🌍️ 🌎️ 🌏️ 🌕️ 🌜️ 🌡️ 🌤️ 🌥️ 🌦️ 🌧️ 🌨️ 🌩️ 🌪️ 🌫️ 🌬️ 🌶️ 🍸️ 🍽️ 🎓️ 🎖️ 🎗️ 🎙️ 🎚️ 🎛️ 🎞️ 🎟️ 🎧️ 🎬️ 🎭️ 🎮️ 🏂️ 🏄️ 🏆️ 🏊️ 🏋️ 🏌️ 🏍️ 🏎️ 🏔️ 🏕️ 🏖️ 🏗️ 🏘️ 🏙️ 🏚️ 🏛️ 🏜️ 🏝️ 🏞️ 🏟️ 🏠️ 🏭️ 🏳️ 🏵️ 🏷️ 🐈️ 🐕️ 🐟️ 🐦️ 🐿️ 👁️ 👂️ 👆️ 👇️ 👈️ 👉️ 👍️ 👎️ 👓️ 👪️ 👽️ 💣️ 💰️ 💳️ 💻️ 💿️ 📋️ 📚️ 📟️ 📤️ 📥️ 📦️ 📪️ 📫️ 📬️ 📭️ 📷️ 📹️ 📺️ 📻️ 📽️ 🔈️ 🔍️ 🔒️ 🔓️ 🕉️ 🕊️ 🕐️ 🕑️ 🕒️ 🕓️ 🕔️ 🕕️ 🕖️ 🕗️ 🕘️ 🕙️ 🕚️ 🕛️ 🕜️ 🕝️ 🕞️ 🕟️ 🕠️ 🕡️ 🕢️ 🕣️ 🕤️ 🕥️ 🕦️ 🕧️ 🕯️ 🕰️ 🕳️ 🕴️ 🕵️ 🕶️ 🕷️ 🕸️ 🕹️ 🖇️ 🖊️ 🖋️ 🖌️ 🖍️ 🖐️ 🖥️ 🖨️ 🖱️ 🖲️ 🖼️ 🗂️ 🗃️ 🗄️ 🗑️ 🗒️ 🗓️ 🗜️ 🗝️ 🗞️ 🗡️ 🗣️ 🗨️ 🗯️ 🗳️ 🗺️ 😐️ 🚇️ 🚍️ 🚑️ 🚔️ 🚘️ 🚭️ 🚲️ 🚹️ 🚺️ 🚼️ 🛋️ 🛍️ 🛎️ 🛏️ 🛠️ 🛡️ 🛢️ 🛣️ 🛤️ 🛥️ 🛩️ 🛰️ 🛳️',
    ['']
  ],
  ['🧑🏻 🧑🏽 🧑🏾 🧑🏿', ['\u200D❤️\u200D💋\u200D🧑🏼', '\u200D❤️\u200D🧑🏼']],
  ['🧑🏻 🧑🏼 🧑🏾 🧑🏿', ['\u200D❤️\u200D💋\u200D🧑🏽', '\u200D❤️\u200D🧑🏽']],
  ['🧑🏻 🧑🏼 🧑🏽 🧑🏿', ['\u200D❤️\u200D💋\u200D🧑🏾', '\u200D❤️\u200D🧑🏾']],
  ['🧑🏻 🧑🏼 🧑🏽 🧑🏾', ['\u200D❤️\u200D💋\u200D🧑🏿', '\u200D❤️\u200D🧑🏿']],
  ['🧑🏼 🧑🏽 🧑🏾 🧑🏿', ['\u200D❤️\u200D💋\u200D🧑🏻', '\u200D❤️\u200D🧑🏻']],
  ['👨 👩', ['\u200D❤️\u200D👨', '\u200D❤️\u200D💋\u200D👨']],
  [
    '👨🏻 👨🏼 👨🏽 👨🏾 👨🏿 👩🏻 👩🏼 👩🏽 👩🏾 👩🏿',
    [
      '\u200D❤️\u200D👨🏻',
      '\u200D❤️\u200D👨🏼',
      '\u200D❤️\u200D👨🏽',
      '\u200D❤️\u200D👨🏾',
      '\u200D❤️\u200D👨🏿',
      '\u200D❤️\u200D💋\u200D👨🏻',
      '\u200D❤️\u200D💋\u200D👨🏼',
      '\u200D❤️\u200D💋\u200D👨🏽',
      '\u200D❤️\u200D💋\u200D👨🏾',
      '\u200D❤️\u200D💋\u200D👨🏿'
    ]
  ],
  ['👩', ['\u200D❤️\u200D👩', '\u200D❤️\u200D💋\u200D👩']],
  [
    '👩🏻 👩🏼 👩🏽 👩🏾 👩🏿',
    [
      '\u200D❤️\u200D👩🏻',
      '\u200D❤️\u200D👩🏼',
      '\u200D❤️\u200D👩🏽',
      '\u200D❤️\u200D👩🏾',
      '\u200D❤️\u200D👩🏿',
      '\u200D❤️\u200D💋\u200D👩🏻',
      '\u200D❤️\u200D💋\u200D👩🏼',
      '\u200D❤️\u200D💋\u200D👩🏽',
      '\u200D❤️\u200D💋\u200D👩🏾',
      '\u200D❤️\u200D💋\u200D👩🏿'
    ]
  ],
  ['🏃 🏃🏻 🏃🏼 🏃🏽 🏃🏾 🏃🏿 🚶 🚶🏻 🚶🏼 🚶🏽 🚶🏾 🚶🏿 🧎 🧎🏻 🧎🏼 🧎🏽 🧎🏾 🧎🏿', ['\u200D➡️', '\u200D♀️\u200D➡️', '\u200D♂️\u200D➡️']],
  [
    '👨 👨🏻 👨🏼 👨🏽 👨🏾 👨🏿 👩 👩🏻 👩🏼 👩🏽 👩🏾 👩🏿 🧑 🧑🏻 🧑🏼 🧑🏽 🧑🏾 🧑🏿',
    ['\u200D⚕️', '\u200D⚖️', '\u200D✈️', '\u200D🦯\u200D➡️', '\u200D🦼\u200D➡️', '\u200D🦽\u200D➡️']
  ],
  [
    '⛹🏻 ⛹🏼 ⛹🏽 ⛹🏾 ⛹🏿 ⛹️ 🏃 🏃🏻 🏃🏼 🏃🏽 🏃🏾 🏃🏿 🏄 🏄🏻 🏄🏼 🏄🏽 🏄🏾 🏄🏿 🏊 🏊🏻 🏊🏼 🏊🏽 🏊🏾 🏊🏿 🏋🏻 🏋🏼 🏋🏽 🏋🏾 🏋🏿 🏋️ 🏌🏻 🏌🏼 🏌🏽 🏌🏾 🏌🏿 🏌️ 👮 👮🏻 👮🏼 👮🏽 👮🏾 👮🏿 👯 👰 👰🏻 👰🏼 👰🏽 👰🏾 👰🏿 👱 👱🏻 👱🏼 👱🏽 👱🏾 👱🏿 👳 👳🏻 👳🏼 👳🏽 👳🏾 👳🏿 👷 👷🏻 👷🏼 👷🏽 👷🏾 👷🏿 💁 💁🏻 💁🏼 💁🏽 💁🏾 💁🏿 💂 💂🏻 💂🏼 💂🏽 💂🏾 💂🏿 💆 💆🏻 💆🏼 💆🏽 💆🏾 💆🏿 💇 💇🏻 💇🏼 💇🏽 💇🏾 💇🏿 🕵🏻 🕵🏼 🕵🏽 🕵🏾 🕵🏿 🕵️ 🙅 🙅🏻 🙅🏼 🙅🏽 🙅🏾 🙅🏿 🙆 🙆🏻 🙆🏼 🙆🏽 🙆🏾 🙆🏿 🙇 🙇🏻 🙇🏼 🙇🏽 🙇🏾 🙇🏿 🙋 🙋🏻 🙋🏼 🙋🏽 🙋🏾 🙋🏿 🙍 🙍🏻 🙍🏼 🙍🏽 🙍🏾 🙍🏿 🙎 🙎🏻 🙎🏼 🙎🏽 🙎🏾 🙎🏿 🚣 🚣🏻 🚣🏼 🚣🏽 🚣🏾 🚣🏿 🚴 🚴🏻 🚴🏼 🚴🏽 🚴🏾 🚴🏿 🚵 🚵🏻 🚵🏼 🚵🏽 🚵🏾 🚵🏿 🚶 🚶🏻 🚶🏼 🚶🏽 🚶🏾 🚶🏿 🤦 🤦🏻 🤦🏼 🤦🏽 🤦🏾 🤦🏿 🤵 🤵🏻 🤵🏼 🤵🏽 🤵🏾 🤵🏿 🤷 🤷🏻 🤷🏼 🤷🏽 🤷🏾 🤷🏿 🤸 🤸🏻 🤸🏼 🤸🏽 🤸🏾 🤸🏿 🤹 🤹🏻 🤹🏼 🤹🏽 🤹🏾 🤹🏿 🤼 🤽 🤽🏻 🤽🏼 🤽🏽 🤽🏾 🤽🏿 🤾 🤾🏻 🤾🏼 🤾🏽 🤾🏾 🤾🏿 🦸 🦸🏻 🦸🏼 🦸🏽 🦸🏾 🦸🏿 🦹 🦹🏻 🦹🏼 🦹🏽 🦹🏾 🦹🏿 🧍 🧍🏻 🧍🏼 🧍🏽 🧍🏾 🧍🏿 🧎 🧎🏻 🧎🏼 🧎🏽 🧎🏾 🧎🏿 🧏 🧏🏻 🧏🏼 🧏🏽 🧏🏾 🧏🏿 🧔 🧔🏻 🧔🏼 🧔🏽 🧔🏾 🧔🏿 🧖 🧖🏻 🧖🏼 🧖🏽 🧖🏾 🧖🏿 🧗 🧗🏻 🧗🏼 🧗🏽 🧗🏾 🧗🏿 🧘 🧘🏻 🧘🏼 🧘🏽 🧘🏾 🧘🏿 🧙 🧙🏻 🧙🏼 🧙🏽 🧙🏾 🧙🏿 🧚 🧚🏻 🧚🏼 🧚🏽 🧚🏾 🧚🏿 🧛 🧛🏻 🧛🏼 🧛🏽 🧛🏾 🧛🏿 🧜 🧜🏻 🧜🏼 🧜🏽 🧜🏾 🧜🏿 🧝 🧝🏻 🧝🏼 🧝🏽 🧝🏾 🧝🏿 🧞 🧟',
    ['\u200D♀️', '\u200D♂️']
  ],
  ['⛓️', ['\u200D💥']],
  ['❤️', ['\u200D🔥', '\u200D🩹']],
  ['🏳️', ['\u200D⚧️', '\u200D🌈']],
  ['🏴', ['\u200D☠️']],
  ['🐻', ['\u200D❄️']],
  ['👁️', ['\u200D🗨️']],
  ['😶', ['\u200D🌫️']],
  ['🙂', ['\u200D↔️', '\u200D↕️']]
]
